import { CommonModule } from '@angular/common';
import { Component, inject, Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MAT_SNACK_BAR_DATA, MatSnackBarModule, MatSnackBarRef } from '@angular/material/snack-bar';

@Component({
  selector: 'app-fd-snackbar',
  standalone: true,
  imports: [
    MatSnackBarModule,
    MatButtonModule,
    MatIconModule,
    CommonModule,
  ],
  templateUrl: './fd-snackbar.component.html',
  styleUrl: './fd-snackbar.component.scss'
})
export class FdSnackbarComponent {
  snackBarRef = inject(MatSnackBarRef);

  constructor(@Inject(MAT_SNACK_BAR_DATA) public data: any) {
  }
}
